'use client'

import { environment } from 'src/environment'
import { useEffect } from 'react'

export const DatadogInit: React.FC = () => {
  useEffect(() => {
    const initializeDatadog = async () => {
      if (environment.NEXT_PUBLIC_ENV !== 'development') {
        const { datadogRum } = await import('@datadog/browser-rum')
        if (datadogRum.getInitConfiguration()) {
          return
        }
        console.info('Initializing Datadog RUM')
        datadogRum.init({
          applicationId: '7f5eacff-27be-4197-b0ab-43073a13c833',
          clientToken: 'pub6ebf1b18f5c6eb87285ea1743a7aa9ed',
          site: 'datadoghq.com',
          service: 'search_ui',
          env: environment.NEXT_PUBLIC_ENV,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 100,
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'mask-user-input',
          allowedTracingUrls: [
            {
              match: /nlpatent|localhost/,
              propagatorTypes: ['datadog', 'tracecontext'],
            },
          ],
        })
      }
    }
    void initializeDatadog()
  }, [])

  return null
}
